<div class="resize-panel"
     [class.resize-panel--horizontal]="orientation === 'horizontal'"
     #resizer>
  <div class="resize-handle">
    <mat-icon svgIcon="resize"></mat-icon>
  </div>
  <div class="resize-indicator"></div>
</div>
